// @flow

import _ from 'lodash';
import { interpolateWith } from 'web-core/src/utils/format';
import type { MemberType } from 'web-core/types/member';
import type { EdeMemberType } from 'types/ede/edeMember.flow';

export type NamePropsType = {
  member: EdeMemberType | MemberType,
  applicantNames: {
    primary: string,
    spouse: string,
    dependent: string,
    depedentAge: string,
  },
  commonMemberTranslations?: Object,
};

export function getName({ member, applicantNames }: NamePropsType) {
  const { first_name, middle_name, last_name, suffix, type, age } = member;

  let name = '';

  if (first_name) {
    name = [first_name, middle_name, last_name, suffix].filter(n => n).join(' ');
  } else if (type === 'dependent' && typeof age === 'number') {
    name = interpolateWith(applicantNames.dependentAge, { age });
  } else {
    name = applicantNames[type];
  }

  return name;
}

export function getPrimaryAndSecondaryName({ member, commonMemberTranslations }: NamePropsType) {
  const { first_name, middle_name, last_name, suffix, type, age, gender: memberGender } = member;

  let primaryName = '';
  let secondaryName = '';

  const types = {
    primary: _.get(commonMemberTranslations, 'primary', 'Me'),
    spouse: _.get(commonMemberTranslations, 'spouse', 'Spouse'),
    dependent: _.get(commonMemberTranslations, 'dependent', 'Dependent'),
  };

  if (first_name) {
    primaryName = [first_name, middle_name, last_name, suffix].filter(n => n).join(' ');
    secondaryName = types[type];
  } else {
    primaryName = types[type];
    const hasAge = age && _.isNumber(age);

    if (commonMemberTranslations && !_.isEmpty(commonMemberTranslations)) {
      if (hasAge && memberGender) {
        const gender =
          memberGender === 'F' ? commonMemberTranslations.female : commonMemberTranslations.male;

        secondaryName = interpolateWith(commonMemberTranslations.ageAndGender, { age, gender });
      } else if (hasAge) {
        secondaryName = interpolateWith(commonMemberTranslations.justAge, { age });
      } else if (memberGender) {
        const gender =
          memberGender === 'F' ? commonMemberTranslations.female : commonMemberTranslations.male;

        secondaryName = interpolateWith(commonMemberTranslations.justGender, { gender });
      }
    } else {
      secondaryName = '';
    }
  }

  return { primaryName, secondaryName };
}
